export default __webpack_public_path__ + "static/media/angle-right.d23158b6.svg";